import { createAsyncThunk } from "@reduxjs/toolkit";
import * as VippsApi from "../../../api/vippsLoginApi";
import { trackEvent } from "../../../utils/tracking";
import { TRACKING_EVENTS } from "../../../utils/trackingDefinitions";

export const connectAccounts = createAsyncThunk(
	"vipps/connectAccounts",
	async ({
		id,
		usernameId,
		password,
		returnUrl,
	}: {
		id: string;
		usernameId?: string;
		password: string;
		returnUrl: string;
	}) => {
		try {
			const response = await VippsApi.connect({
				id,
				usernameId,
				password,
				returnUrl,
			});

			if (response.isSuccess) {
				trackEvent({
					event: TRACKING_EVENTS.PASSWORD.EVENT.USER_INTERACTION,
					target: TRACKING_EVENTS.PASSWORD.APP,
					key: "action",
					value: TRACKING_EVENTS.PASSWORD.EVENT.RESET_PASSWORD_TRIGGERED,
				});

				window.location.href = response.returnUrl;
			}

			return {
				isSuccess: response.isSuccess,
				error: response.errors?.[0],
				result: response,
			};
		} catch (error) {
			return { error: "komid.general.network.error" };
		}
	},
);

export const createAccountWithVippsData = createAsyncThunk(
	"vipps/createAccountWithVippsData",
	async ({ id, returnUrl }: { id: string; returnUrl: string }) => {
		try {
			const response = await VippsApi.createAccount({
				id,
				returnUrl,
			});

			if (response.isSuccess) {
				trackEvent({
					event: TRACKING_EVENTS.PASSWORD.EVENT.USER_INTERACTION,
					target: TRACKING_EVENTS.PASSWORD.APP,
					key: "action",
					value: TRACKING_EVENTS.PASSWORD.EVENT.RESET_PASSWORD_TRIGGERED,
				});

				window.location.href = response.returnUrl;
			}

			return {
				isSuccess: response.isSuccess,
				error: response.errors?.[0],
				result: response,
			};
		} catch (error) {
			return { error: "komid.general.network.error" };
		}
	},
);

export const getMatchingEmails = createAsyncThunk(
	"vipps/getMatchingEmails",
	async (vippsId: string) => {
		try {
			const response = await VippsApi.getMatchedEmails(vippsId);

			return {
				isSuccess: response.isSuccess,
				error: response.errors?.[0],
				result: response.data,
			};
		} catch (error) {
			return { error: "komid.general.network.error" };
		}
	},
);
